// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1-LLE","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__5fPHW"};